import '@farol-ds/react/index.css'

import { FarolProvider } from '@farol-ds/react'
import { Topbar } from '@jusbrasil/topbar'
import { ApolloProvider } from '@jusbrasil-web/core-apollo'
import { configureReportWebVitals } from '@jusbrasil-web/core-next'
import { NextFarolProvider } from '@jusbrasil-web/core-next/farol'
import { AppRootProvider } from '@jusbrasil-web/shared-app-root-provider'
import { isFrameBusPage } from '@jusbrasil-web/shared-frame-bus'
import { GTMProvider } from '@jusbrasil-web/shared-gtm'
import { AppProps } from 'next/app'
import Head from 'next/head'

function CustomApp({ Component, pageProps }: AppProps) {
  if (isFrameBusPage(pageProps)) {
    return <Component {...pageProps} />
  }

  return (
    <AppRootProvider pageProps={pageProps}>
      <Head>
        <title>Welcome to docview!</title>
      </Head>

      <NextFarolProvider />

      <FarolProvider experimental={{ flags: pageProps.farolFlags }}>
        <Topbar.Provider pageProps={pageProps}>
          <GTMProvider appId="web-docview" contentGroup="document" />
          <ApolloProvider pageProps={pageProps}>
            <Component {...pageProps} />
          </ApolloProvider>
        </Topbar.Provider>
      </FarolProvider>
    </AppRootProvider>
  )
}

export const reportWebVitals = configureReportWebVitals()

export default CustomApp
